import {
  useChangeEmail,
  useChangePassword,
  useForgetPassword,
  useGetSession,
  useResetPassword,
  useSignInEchoes,
  useSignInEmail,
  useSignInLine,
  useSignOut,
  useSignUpEmail,
  useUpdateProfile,
} from "./hooks"
import {
  authResponseSchema,
  changeEmailRequestSchema,
  changePasswordRequestSchema,
  forgetPasswordRequestSchema,
  resetPasswordRequestSchema,
  signInEmailRequestSchema,
  signUpEmailRequestSchema,
  updateProfileRequestSchema,
} from "./schemas"

export * as AuthModels from "./models"

export const authApi = {
  useSignUpEmail,
  useSignInEmail,
  useSignInLine,
  useSignInEchoes,
  useGetSession,
  useSignOut,
  useUpdateProfile,
  useChangeEmail,
  useChangePassword,
  useForgetPassword,
  useResetPassword,
}

export const authSchemas = {
  signUpEmailRequest: signUpEmailRequestSchema,
  signInEmailRequest: signInEmailRequestSchema,
  authResponse: authResponseSchema,
  updateProfileRequest: updateProfileRequestSchema,
  changeEmailRequest: changeEmailRequestSchema,
  changePasswordRequest: changePasswordRequestSchema,
  forgetPasswordRequest: forgetPasswordRequestSchema,
  resetPasswordRequest: resetPasswordRequestSchema,
}

export {
  useChangeEmail,
  useChangePassword,
  useForgetPassword,
  useResetPassword,
  useSignInEchoes,
  useSignInEmail,
  useSignInLine,
  useSignUpEmail,
  useUpdateProfile,
} from "./hooks"
export type {
  AuthError,
  ChangeEmailResponse,
  ChangePasswordResponse,
  ForgetPasswordResponse,
  ResetPasswordResponse,
  SignInEmailRequest,
  SignInEmailResponse,
  SignUpEmailResponse,
  UpdateProfileResponse,
} from "./models"
export type {
  ChangeEmailRequest,
  ChangePasswordRequest,
  ForgetPasswordRequest,
  ResetPasswordRequest,
  SignUpEmailRequest,
  UpdateProfileRequest,
} from "./schemas"
